/* global FlowbiteInstances */
import { initFlowbiteModal, showFlowbiteModal } from 'Scripts/initializeFlowBiteModals';

const MODAL_ID = 'contingency-notice';

// Lower case: how axios exposes response header names.
export const CONTINGENCY_NOTICE_HEADER = 'x-contingency-notice';

// Kept until the user closes the pop-up, so a page that reloads or redirects as soon as
// the action completes still shows it on the next page.
const STORAGE_KEY = 'contingency-notice';

const store = (messages) => {
    try {
        if (messages) {
            window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(messages));
        } else {
            window.sessionStorage.removeItem(STORAGE_KEY);
        }
    } catch (e) {
        // Storage can be unavailable; the pop-up still shows on this page.
    }
};

const stored = () => {
    try {
        return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)) ?? [];
    } catch (e) {
        return [];
    }
};

const buildModal = () => {
    const modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.tabIndex = -1;
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('aria-labelledby', `${MODAL_ID}-title`);
    modal.className = 'tw-hidden modal__box';
    modal.innerHTML = `
        <div class="modal__container">
            <div class="modal__inner-container">
                <div class="tw-mb-4 tw-flex tw-flex-row tw-items-center tw-justify-between tw-rounded-t">
                    <h3 id="${MODAL_ID}-title" class="tw-text-2xl tw-font-semibold tw-text-blue"></h3>
                </div>
                <div class="modal__form-container tw-flex tw-flex-col tw-gap-1.5">
                    <ul class="modal__text tw-list-disc tw-ps-5 tw-space-y-1"></ul>
                    <div class="modal__footer">
                        <button type="button" class="button primary" data-modal-hide="${MODAL_ID}"></button>
                    </div>
                </div>
            </div>
        </div>`;

    document.body.appendChild(modal);

    modal.querySelector(`#${MODAL_ID}-title`).textContent = $t('Contingency returned');
    modal.querySelector(`[data-modal-hide="${MODAL_ID}"]`).textContent = $t('OK');

    initFlowbiteModal(MODAL_ID);

    // The close button, Esc and a backdrop click all end here.
    $(document).on('modalHidden', (event, modalId) => {
        if (modalId !== MODAL_ID) {
            return;
        }

        document.body.classList.remove('tw-overflow-hidden');
        store(null);
    });

    return modal;
};

/**
 * Tells the user where contingency handed back by their action went. The messages
 * are already translated by the server. They join any the user has not closed yet:
 * a bulk action returns contingency over several requests.
 */
export const showContingencyNotice = (messages, { append = true } = {}) => {
    if (!Array.isArray(messages) || messages.length === 0) {
        return;
    }

    const all = append ? [...stored(), ...messages] : messages;
    const modal = document.getElementById(MODAL_ID) ?? buildModal();
    const list = modal.querySelector('ul');

    // textContent, never markup: the messages carry location names.
    list.replaceChildren(
        ...all.map((message) => {
            const item = document.createElement('li');
            item.textContent = message;

            return item;
        }),
    );

    store(all);

    const instance = FlowbiteInstances.getInstance('Modal', MODAL_ID);

    if (instance.isHidden()) {
        showFlowbiteModal(instance, MODAL_ID);
    }
};

/**
 * Shows the notice a response carries in its header, if any.
 */
export const showContingencyNoticeFromHeader = (value) => {
    if (!value) {
        return;
    }

    try {
        showContingencyNotice(JSON.parse(value));
    } catch (e) {
        // A malformed header is not worth interrupting the user over.
    }
};

/**
 * A notice the previous page showed but the user never closed, because the page
 * moved on straight after the action.
 */
export const showStoredContingencyNotice = () => showContingencyNotice(stored(), { append: false });
